const ida = [

    {label:"Date of test",
    controlType:"date",
    options:[],
    },
    
    {label:"Lab where test performed:",
    controlType:"text",
    options:[],
    },

    {label:"Use values from IDA checker",
    controlType:"radio button",
    options:["Yes","No"],
    },

    {label:"Result(s) (if not available electonically):",
    controlType:"text area",
    options:[],
    },
    
    {label:"Comments",
    controlType:"text area",
    options:[],
    },
    
    ]
    
    export default ida